"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSort = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _interfaces = require("./interfaces");

var useSort = function useSort() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defaultSortDirection = _ref.defaultSortDirection,
      defaultActiveSortId = _ref.defaultActiveSortId;

  var _useState = (0, _react.useState)(defaultSortDirection || _interfaces.SortDirection.None),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sortDirection = _useState2[0],
      setSortDirection = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultActiveSortId),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      activeSortId = _useState4[0],
      setActiveSortId = _useState4[1];

  var onSort = function onSort(_ref2) {
    var sortId = _ref2.sortId,
        sortDirection = _ref2.sortDirection;
    setSortDirection(sortDirection);
    setActiveSortId(sortId);
  };

  return {
    activeSortId: activeSortId,
    sortDirection: sortDirection,
    onSort: onSort
  };
};

exports.useSort = useSort;